import { render, staticRenderFns } from "./EmployeeHiringBadge.vue?vue&type=template&id=1ac7cb82&scoped=true&"
import script from "./EmployeeHiringBadge.vue?vue&type=script&lang=js&"
export * from "./EmployeeHiringBadge.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeHiringBadge.vue?vue&type=style&index=0&id=1ac7cb82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7cb82",
  null
  
)

export default component.exports